/**
 * @author vishwadeep.kapoor
 */
import React, { Fragment, PureComponent } from 'react';

import { HeaderContainer } from '../HeaderContainer/Loadable';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader';
import { fbTracker } from '../../devUtils';

function AppWrappperHOC(WrappedComponent) {
  return class AppWrappper extends PureComponent {
    constructor(props) {
      super(props);
      this.state = { isLoading: true };
    }

    componentWillMount() {
      ValidateTracker(this.props);
    }

    componentDidMount() {
      this.hideLoader();
    }

    hideLoader() {
      const proc = new Promise((resolve) => {
        setTimeout(() => resolve(), 50);
      });
      proc.then(() => this.setState({ isLoading: false }));
    }

    render() {
      const { isLoading } = this.state;
      if (isLoading) {
        return <Loader />;
      }
      return (
        <Fragment>
          <HeaderContainer location={this.props} />
          <div className="stickyBody"><WrappedComponent {...this.props} /></div>
          <Footer />
        </Fragment>
      );
    }
  };
}

export { AppWrappperHOC };

/**
 * @desc initilizing the analytics it should be configured in the routes.js
 */
const ValidateTracker = ({ route: { isFbAnalyticsEnabled } = {} }) => {
  if (isFbAnalyticsEnabled) {
    fbTracker.trackPageView();
  }
};



// WEBPACK FOOTER //
// client/containers/Root/HOC.js